<template>
	<el-submenu v-if="item.child && item.child.length" :index="navIndex">
		<!-- 创建父级菜单 -->
		<template slot="title">
			<i v-if="item.icon" :class="item.icon"></i>
			<span v-if="isCollapse">{{ item.name }}</span>
		</template>
		<!-- 创建子菜单 -->
		<nav-bar-item v-for="(subItem, i) in item.child" :key="navIndex + '-' + i" :navIndex="navIndex + '-' + i" :item="subItem"></nav-bar-item>
	</el-submenu>

	<el-menu-item v-else :index="item.path" :route="{ path: item.path }">
		<i v-if="item.icon" :class="item.icon"></i>
		<span v-if="!isCollapse">{{ item.name }}</span>
	</el-menu-item>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'NavItem',
	props: ['item', 'navIndex'],
	computed: {
		...mapGetters(['sidebar']),
		isCollapse() {
			return !this.sidebar.opened;
		}
	}
};
</script>

<style></style>
